import { render, staticRenderFns } from "./AnswerInfo.vue?vue&type=template&id=d505405a&scoped=true&"
import script from "./AnswerInfo.vue?vue&type=script&lang=ts&"
export * from "./AnswerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerInfo.vue?vue&type=style&index=0&id=d505405a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d505405a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VContainer,VSimpleTable})
